module.exports = __webpack_public_path__ + "img/Asset 1.85428053.png";